import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';

const WizardProgress = ({ currentStep }) => {
  const { t } = useTranslation('wizard');
  const steps = [1, 2];

  return (
    <div className="wizard-progress">
      {steps.map((step) => (
        <div 
          key={step}
          className={`wizard-step ${currentStep >= step ? 'completed' : ''}`}
        >
          <div className="step-number">{step}</div>
          <span className="step-label">{t(`progress.step${step}`)}</span>
        </div>
      ))}
    </div>
  );
};

export default WizardProgress; 